import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';
import { ApiProjectService } from 'src/app/modules/project/services/http/api-project.service';

@Component({
  selector: 'app-relay-outputs-list',
  templateUrl: './relay-outputs-list.component.html',
  styleUrl: './relay-outputs-list.component.scss',
})
export class RelayOutputsListComponent {
  @Input({ required: true }) selectedControllers: Controller[];
  @Input({ required: true }) updated: Date;
  Property = Property;
  useHiddenFilter = false;

  constructor(
    private apiProjectService: ApiProjectService,
    private popoverController: PopoverController
  ) {}

  activateRelayOutputProp(
    findPropFunction: (property: Property) => boolean,
    value,
    outputStatusNumber: string
  ) {
    this.popoverController
      .getTop()
      .then((v) => (v ? this.popoverController.dismiss() : null));
    let property: Property;
    const parentController: Controller = this.selectedControllers.find(
      (controller: Controller) => {
        property = controller.controllerProperties.$values.find((prop) => {
          return (
            findPropFunction(prop) &&
            prop.mqttTopic.endsWith(outputStatusNumber)
          );
        });
        return property;
      }
    );
    if (parentController && property) {
      const designation = parentController.designation;
      const propertyId = property.id;
      this.apiProjectService
        .changeProperty(designation, propertyId, value)
        .subscribe(() => {
          // this.reqInProgress = false;
        });
    }
  }

  toggleRelayOutputValue(
    event: any,
    findPropFunction: (property: Property) => boolean,
    relayStatusNumber
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.cancelBubble = true;
    event.stopPropagation();
    let property: Property;
    const parentController: Controller = this.selectedControllers.find(
      (controller: Controller) => {
        property = controller.controllerProperties.$values.find((prop) => {
          return (
            findPropFunction(prop) && prop.mqttTopic.endsWith(relayStatusNumber)
          );
        });
        return property;
      }
    );
    if (parentController && property) {
      const designation = parentController.designation;
      const propertyId = property.id;
      if (!event.target.checked) {
        this.apiProjectService
          .changeProperty(designation, propertyId, 1)
          .subscribe();
      } else {
        this.apiProjectService
          .changeProperty(designation, propertyId, 0)
          .subscribe();
      }
    }
  }

  syncRekuperator() {
    const cont = Controller.getMainController(this.selectedControllers);
    const rekPropsIds = cont.controllerProperties.$values
      .filter(
        (prop) =>
          Property.isRelayOutputByRentedOrPresence(prop) ||
          Property.isRelayOutputForceOn(prop) ||
          Property.isRelayOutputForceOff(prop) ||
          Property.isRelayOutputInCooling(prop) ||
          Property.isRelayOutputAutoMode(prop) ||
          Property.isRelayOutputControl(prop)
      )
      .map((prop) => prop.id);
    this.apiProjectService
      .syncControllerProperties(rekPropsIds)
      .subscribe((value) => {});
  }
}
